/** Allowed MIME types for image uploads */
export const ALLOWED_IMAGE_TYPES = new Set(['image/jpeg', 'image/png', 'image/webp'])

/** Maximum image file size in bytes (5 MB) */
export const MAX_IMAGE_SIZE_BYTES = 5 * 1024 * 1024

/** Maximum decal image file size in bytes (100 kB) — decals are expected to be tiny images */
export const MAX_DECAL_IMAGE_SIZE_BYTES = 100 * 1024

/** Allowed MIME types for the image-converter tool — broader than icon/decal uploads, includes legacy formats it converts between */
export const CONVERTER_ALLOWED_IMAGE_TYPES = new Set([
  'image/jpeg',
  'image/png',
  'image/webp',
  'image/gif',
  'image/bmp',
  'image/x-icon',
  'image/vnd.microsoft.icon',
])

/** Maximum image-converter input file size in bytes (25 MB) — general-purpose photos, not tiny app-icon sources */
export const CONVERTER_MAX_IMAGE_SIZE_BYTES = 25 * 1024 * 1024

/** Maximum creative-assets image size in bytes (25 MB) — backgrounds and key art for 3840–5244 px canvases are large */
export const CREATIVE_MAX_IMAGE_SIZE_BYTES = 25 * 1024 * 1024
